import React, { CSSProperties, FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

interface LineButtonProps {
    onClick?: () => void
    className?: string
    style?: CSSProperties
    disabled?: boolean
}

export const LineButton: FC<PropsWithChildren<LineButtonProps>> = ({
    onClick,
    children,
    className,
    style,
    disabled = false
}) => {
    return (
        <Content
            className={`
                group bg-white border border-black inline-block rounded-full flex items-center justify-center transition
                ${className}
                ${disabled ? 'disabled' : ''}
            `}
            style={style}
            onClick={() => !disabled && onClick?.()}
        >
            <span>{children}</span>
        </Content>
    )
}

const Content = styled.div`
    height: 36px;
    cursor: pointer;
    font-family: Roboto-Medium;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    font-size: 18px;
    color: #000;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
    margin-left: 14px;
    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
    &:hover {
        opacity: 0.8;
    }
    > span {
        display: inline-block;
        padding: 0 13px;
    }
`
